'use client';

import {
  Button,
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import Image from 'next/image';

export const DiscordCTA = () => {
  return (
    <Popover className="fixed right-4 bottom-4 z-10 sm:right-8 sm:bottom-8">
      <PopoverButton className="flex size-15 items-center justify-center rounded-[40px] border border-[#6A75EA] bg-[#5865F2] shadow-[inset_0_4px_3px_0_#7882F2] outline-none">
        {DiscordIcon}
      </PopoverButton>
      <Transition
        enter="transform transition duration-200"
        enterFrom="opacity-0 translate-y-2"
        enterTo="opacity-100"
        leave="transform transition duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0 translate-y-2"
      >
        <PopoverPanel className="absolute right-0 bottom-[calc(100%_+_10px)] w-xs rounded-lg bg-[#5865F2] p-5">
          {({ close }) => (
            <div className="flex flex-col">
              <header className="flex items-start justify-between">
                <h6 className="font-semibold text-[#FFFFFF] text-base/6.5">
                  Join our Discord
                </h6>
                <Button
                  className="text-[#C8CBF2]"
                  onClick={() => {
                    close();
                  }}
                >
                  <XMarkIcon height={18} width={18} />
                </Button>
              </header>
              <p className="mb-2 font-normal text-[#C8CBF2] text-sm/6.5">
                Live picks, Bonuses, Community
              </p>
              {DiscordCharacters}
              <a
                className="mt-5 inline-flex h-10 items-center justify-center rounded-lg border border-[#EAEBED] bg-[#F0F0F0] font-bold text-[#0D1D29] text-sm/4 shadow-[inset_0_4px_4px_0_#FFFFFF]"
                href="https://discord.gg/tG5etK3ZeZ"
                onClick={() => {
                  close();
                }}
                rel="noopener"
                target="_blank"
              >
                Join our Discord
              </a>
            </div>
          )}
        </PopoverPanel>
      </Transition>
    </Popover>
  );
};

const DiscordIcon = (
  <svg
    aria-label="Discord icon"
    fill="none"
    height="19"
    role="img"
    viewBox="0 0 26 19"
    width="26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.1973 1.58833C19.5533 0.835629 17.8176 0.30164 16.0348 0C15.7908 0.436127 15.5701 0.884843 15.3735 1.34427C13.4744 1.0581 11.5432 1.0581 9.64409 1.34427C9.44739 0.88489 9.22665 0.436179 8.98278 0C7.19879 0.304187 5.46202 0.839444 3.81629 1.59226C0.549105 6.42613 -0.336579 11.1399 0.106263 15.7868C2.01961 17.2005 4.16119 18.2756 6.43792 18.9654C6.95057 18.2759 7.4042 17.5445 7.794 16.7788C7.05363 16.5023 6.33905 16.1611 5.65852 15.7593C5.83762 15.6294 6.01279 15.4955 6.18205 15.3656C8.16224 16.2969 10.3235 16.7797 12.5117 16.7797C14.7 16.7797 16.8612 16.2969 18.8414 15.3656C19.0127 15.5054 19.1878 15.6392 19.365 15.7593C18.6831 16.1618 17.9672 16.5036 17.2255 16.7808C17.6149 17.5461 18.0685 18.2769 18.5816 18.9654C20.8603 18.2784 23.0035 17.2038 24.9172 15.7888C25.4368 10.3999 24.0296 5.72939 21.1973 1.58833ZM8.35493 12.929C7.12088 12.929 6.10136 11.8091 6.10136 10.4314C6.10136 9.05366 7.08545 7.92392 8.35099 7.92392C9.61654 7.92392 10.6282 9.05366 10.6065 10.4314C10.5849 11.8091 9.6126 12.929 8.35493 12.929ZM16.6685 12.929C15.4325 12.929 14.4169 11.8091 14.4169 10.4314C14.4169 9.05366 15.401 7.92392 16.6685 7.92392C17.9361 7.92392 18.9398 9.05366 18.9182 10.4314C18.8965 11.8091 17.9262 12.929 16.6685 12.929Z"
      fill="white"
    />
  </svg>
);

const DiscordCharacters = (
  <div className="relative">
    <Image
      alt="Discord character"
      height={30}
      loading="eager"
      src="/assets/characters/discord_character1.svg"
      width={30}
    />
    <Image
      alt="Discord character"
      className="absolute top-0 left-[25px]"
      height={30}
      loading="eager"
      src="/assets/characters/discord_character2.svg"
      width={30}
    />
    <Image
      alt="Discord character"
      className="absolute top-0 left-[50px]"
      height={30}
      loading="eager"
      src="/assets/characters/discord_character3.svg"
      width={30}
    />
    <Image
      alt="Discord character"
      className="absolute top-0 left-[75px]"
      height={30}
      loading="eager"
      src="/assets/characters/discord_character4.svg"
      width={30}
    />
  </div>
);
